module.exports = __webpack_public_path__ + "static/media/Mervin.138d8d71.png";